module.exports = __webpack_public_path__ + "img/sfq5.43818cb8.png";